import styled from 'styled-components';
import { Color } from '../../../../../constants/Colors';
import { FontSize, FontType } from '../../../../../constants/Fonts';
import { MediaQuery, Shadow } from '../../../../../constants/Styles';
import { Typography } from '../../../../../constants/Typographies';

export const InstantSearchWrapper = styled.div`
  position: relative;
  margin: 0px 15px;

  ${MediaQuery.L_AND_DOWN} {
    margin: initial;
  }
`;

export const AlgoliaSearchHeader = styled.div`
  position: relative;
  flex-grow: 1;
  max-width: 520px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  svg:first-of-type {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    color: ${Color.CLOUD_BURST};
  }

  ${MediaQuery.L_AND_DOWN} {
    max-width: 360px;
    margin-right: 15px;
    margin-left: 15px;
  }

  button {
    display: none;
  }
`;

export const StyledSearchBox = styled.div`
  position: relative;
  width: 100%;

  input {
    width: 520px;
    display: flex;
    flex-grow: 1;
    padding: 9.5px 12px 9.5px 52px;
    margin: 0
    box-sizing: border-box;
    border-radius: 22.5px;
    color: ${Color.CLOUD_BURST};
    font-family: ${FontType.PRIMARY};
    font-size: ${FontSize.M};
    background-color: transparent;
    letter-spacing: 0;
    line-height: 22px;
    outline: none;
    border: 2px solid ${Color.MYSTIC};

    &::placeholder {
      color: ${Color.DOLPHIN};
    }

    &:disabled {
      background-color: ${Color.MYSTIC}
    }

    &:focus-visible {
        border: 2px solid ${Color.CLOUD_BURST};
    }
  }

  input[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
    display: none;
  }

  button {
    display: none;
  }

  ${MediaQuery.L_AND_DOWN} {
    input {
      width: 100%;
    }
  }
`;

export const AlgoliaSearchMain = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  max-width: 520px;
  width: 100%;
  max-height: 400px;
  z-index: 100;

  background: ${Color.WHITE};
  box-shadow: ${Shadow.BLUE_ACTIVE};
  border-radius: 15px;

  overflow: hidden;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 15px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${Color.MYSTIC};
    border-radius: 20px;
    border: 3px solid ${Color.WHITE};
  }

  ${MediaQuery.L_AND_DOWN} {
    margin: 0px 15px;
  }
`;

export const CustomHistsContainer = styled.div`
  padding: 15px;

  ol {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  li {
    list-style-type: none;
  }
`;

export const HitsItem = styled.li`
  list-style: none;
  padding: 15px;
  margin: 15px;
  border-radius: 15px;
  &:hover {
    background: ${Color.WHISPER};
  }
`;

export const HitContainer = styled.a`
  display: block;
  text-decoration: none;
  padding: 15px;
  border-radius: 10px;

  &:hover {
    background: ${Color.WHISPER};
  }
`;

export const PageTitle = styled.div``;

export const Title = styled.p`
  ${Typography.L_BOLDER};
  color: ${Color.CLOUD_BURST};
  padding-bottom: 5px;
`;

export const PageDescription = styled.div`
  margin-top: 5px;
`;

export const Description = styled.p`
  ${Typography.M};
  color: ${Color.DOLPHIN};
`;
